module.exports = __webpack_public_path__ + "img/high-techEnterprise.61be70b3.png";